export type Theme = "light" | "dark";

const KEY = "akhshy-theme";

export function getStoredTheme(): Theme | null {
  const v = localStorage.getItem(KEY);
  return v === "light" || v === "dark" ? v : null;
}

export function systemTheme(): Theme {
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function currentTheme(): Theme {
  return (document.documentElement.getAttribute("data-theme") as Theme | null) ?? "light";
}

export function applyTheme(theme: Theme): void {
  document.documentElement.setAttribute("data-theme", theme);
}

/** Called once at startup: respects stored choice, else system preference. Light is default. */
export function initTheme(): void {
  applyTheme(getStoredTheme() ?? systemTheme());
}

export function toggleTheme(): Theme {
  const next: Theme = currentTheme() === "dark" ? "light" : "dark";
  applyTheme(next);
  localStorage.setItem(KEY, next);
  return next;
}
